import React, { useState, useEffect } from "react";
import Select from "./form/Select";
import Input from "./form/Input";
import Checkbox from "./form/Checkbox";
import useFormHook from "../hooks/useForm";
import Textarea from "./form/Textarea";
import { GrFormTrash } from "react-icons/gr";

const ProductTypes = [
  { value: "Turbine", label: "Turbine (luftgetrieben)" },
  { value: "Winkelstueck", label: "Winkelstück / Handstück (motorgetrieben)" },
  { value: "Dentalmotor", label: "Elektrischer Dentalmotor" },
  { value: "Scaler", label: "Zahnsteinentfernungsgerät / Scaler" },
  { value: "Schlauch", label: "Schlauch" },
  { value: "Kupplungen", label: "Kupplungen" },
  { value: "Winkelstück Köpfe", label: "Winkelstück Köpfe" },
];

const Manufacturers = [
  { value: "KaVo", label: "KaVo" },
  { value: "NSK", label: "NSK" },
  { value: "Sirona", label: "Sirona" },
  { value: "W&H", label: "W&H" },
  { value: "Bien Air", label: "Bien Air" },
  { value: "B.A. International", label: "B.A. International" },
  { value: "MK-dent", label: "MK-dent" },
];

const Models = {
  Turbine: {
    KaVo: [
      { value: "KaVo GENTLEmini 5000", label: "KaVo GENTLEmini 5000" },
      {
        value: "KaVo SUPERtorque 625 / 630 / 640",
        label: "KaVo SUPERtorque 625 / 630 / 640",
      },
      {
        value: "KaVo COMPACTtorque 636 / POWERtorque 646B",
        label: "KaVo COMPACTtorque 636 / POWERtorque 646B",
      },
      {
        value: "KaVo BELLAtorque 637",
        label: "KaVo BELLAtorque 637",
      },
      {
        value: "KaVo BELLAtorque 639 / 642 / 645",
        label: "KaVo BELLAtorque 639 / 642 / 645",
      },
      { value: "KaVo SUPERtorque 650", label: "KaVo SUPERtorque 650" },
      {
        value: "KaVo SUPERtorque 655 / 660",
        label: "KaVo SUPERtorque 655 / 660",
      },
      {
        value: "KaVo EXPERTtorque Mini E677 L",
        label: "KaVo EXPERTtorque Mini E677 L",
      },
      { value: "KaVo EXPERTtorque E680 L", label: "KaVo EXPERTtorque E680 L" },
      { value: "KaVo GENTLEforce 7000", label: "KaVo GENTLEforce 7000" },
      { value: "KaVo GENTLEsilence 8000", label: "KaVo GENTLEsilence 8000" },
      {
        value: "KaVo MASTERtorque M9000 L",
        label: "KaVo MASTERtorque M9000 L",
      },
      { value: "KaVo 637B Mira Lux", label: "KaVo 637B Mira Lux" },
    ],
    "W&H": [
      { value: "W&H Synea TA 98 (L)", label: "W&H Synea TA 98 (L)" },
      { value: "W&H Synea TA 98 LED", label: "W&H Synea TA 98 LED" },
      { value: "W&H Synea TA 97 LED", label: "W&H Synea TA 97 LED" },
      {
        value: "W&H Fusion TG 98 / Synea TA 98 CLED",
        label: "W&H Fusion TG 98 / Synea TA 98 CLED",
      },
      { value: "W&H Vision TK 98", label: "W&H Vision TK 98" },
      { value: "W&H Alegra TE 98(L)", label: "W&H Alegra TE 98(L)" },
    ],
    Sirona: [
      { value: "Sirona T2 / T3 Racer", label: "Sirona T2 / T3 Racer" },
      { value: "Sirona T1 Control TC3", label: "Sirona T1 Control TC3" },
      { value: "Sirona T1 Control CS", label: "Sirona T1 Control CS" },
      {
        value: "Sirona SiroPure P Control",
        label: "Sirona SiroPure P Control",
      },
      { value: "Sirona T1 Boost", label: "Sirona T1 Boost" },
      { value: "Sirona T2/T3 Boost", label: "Sirona T2/T3 Boost" },
    ],
    NSK: [
      { value: "NSK S-Max M600", label: "NSK S-Max M600" },
      { value: "NSK Ti-Max X500", label: "NSK Ti-Max X500" },
      { value: "NSK Ti-Max X600", label: "NSK Ti-Max X600" },
      { value: "NSK Ti-Max X700", label: "NSK Ti-Max X700" },
      { value: "NSK Ti-Max Z900", label: "NSK Ti-Max Z900" },
    ],
    "Bien Air": [
      { value: "Bien Air Bora", label: "Bien Air Bora" },
      { value: "Bien Air Prestige", label: "Bien Air Prestige" },
      { value: "Bien Air Tornado", label: "Bien Air Tornado" },
    ],
    "B.A. International": [
      { value: "BA 635 Ultimate", label: "BA 635 Ultimate" },
      { value: "BA 650 Ultimate", label: "BA 650 Ultimate" },
      {
        value: "BA 675/680/685/695 Ultimate",
        label: "BA 675/680/685/695 Ultimate",
      },
      { value: "BA 755 Ultimate Power+", label: "BA 755 Ultimate Power+" },
    ],
    "MK-dent": [
      {
        value: "MK-dent HC2001/2002/2011/2022",
        label: "MK-dent HC2001/2002/2011/2022",
      },
      { value: "MK-dent HC4011/4021/5021", label: "MK-dent HC4011/4021/5021" },
      {
        value: "MK-dent HC2003/2004/2013/2014",
        label: "MK-dent HC2003/2004/2013/2014",
      },
      { value: "MK-dent HC8021/9021", label: "MK-dent HC8021/9021" },
      { value: "MK-dent TC8022/9022", label: "MK-dent TC8022/9022" },
    ],
  },
  Winkelstueck: {
    KaVo: [
      { value: "KaVo MASTERmatic M25L", label: "KaVo MASTERmatic M25L" },
      {
        value: "KaVo GENTLEforce 25LP / 25LPA / 25LPR",
        label: "KaVo GENTLEforce 25LP / 25LPA / 25LPR",
      },
      {
        value: "KaVo INTRAmatic 25LH / 25LHA / 25LHN",
        label: "KaVo INTRAmatic 25LH / 25LHA / 25LHN",
      },
      {
        value: "KaVo EXPERTmatic E25L / E25C",
        label: "KaVo EXPERTmatic E25L / E25C",
      },
      { value: "KaVo INTRAmatic 20LN", label: "KaVo INTRAmatic 20LN" },
      { value: "KaVo INTRAmatic 20LH", label: "KaVo INTRAmatic 20LH" },
      { value: "KaVo GENTLEpower 20LP", label: "KaVo GENTLEpower 20LP" },
      { value: "KaVo MASTERmatic M20L", label: "KaVo MASTERmatic M20L" },
      { value: "KaVo INTRAmatic 7LN", label: "KaVo INTRAmatic 7LN" },
      { value: "KaVo INTRAmatic 7LH", label: "KaVo INTRAmatic 7LH" },
      { value: "KaVo GENTLEpower 7LP", label: "KaVo GENTLEpower 7LP" },
      { value: "KaVo MASTERmatic M7L", label: "KaVo MASTERmatic M7L" },
      { value: "KaVo INTRAmatic 29LN", label: "KaVo INTRAmatic 29LN" },
      { value: "KaVo INTRAmatic 29LH", label: "KaVo INTRAmatic 29LH" },
      { value: "KaVo GENTLEpower 29LP", label: "KaVo GENTLEpower 29LP" },
      { value: "KaVo MASTERmatic M29L", label: "KaVo MASTERmatic M29L" },
    ],
    "W&H": [
      { value: "W&H WA-99 A", label: "W&H WA-99 A" },
      { value: "W&H WA-99 LT", label: "W&H WA-99 LT" },
      { value: "W&H WA-56", label: "W&H WA-56" },
    ],
    Sirona: [
      {
        value: "Sirona T1 Line C 200 L alt",
        label: "Sirona T1 Line C 200 L alt",
      },
      {
        value: "Sirona T1 Line A 200 L",
        label: "Sirona T1 Line A 200 L",
      },
      {
        value: "Sirona T1 Line S 200 L",
        label: "Sirona T1 Line S 200 L",
      },
      {
        value: "Sirona T1 Line C 200 L neu (SN > 68381)",
        label: "Sirona T1 Line C 200 L neu (SN > 68381)",
      },
      {
        value: "Sirona T1 Line C 40 alt (grosse Kopf)",
        label: "Sirona T1 Line C 40 alt (grosse Kopf)",
      },
      {
        value: "Sirona T1 Line C 40 neu (SN > 65000)",
        label: "Sirona T1 Line C 40 neu (SN > 65000)",
      },
      { value: "Sirona T1 Line C 10", label: "Sirona T1 Line C 10" },
      { value: "Sirona T1 Endo 6L", label: "Sirona T1 Endo 6L" },
    ],
    NSK: [
      { value: "NSK Ti-Max Z95(L)", label: "NSK Ti-Max Z95(L)" },
      { value: "NSK Ti-Max Ti95(L)", label: "NSK Ti-Max Ti95(L)" },
      { value: "NSK Ti-Max X95(L)", label: "NSK Ti-Max X95(L)" },
      { value: "NSK S-Max M95(L)", label: "NSK S-Max M95(L)" },
      { value: "NSK Ti-Max Z25(L)", label: "NSK Ti-Max Z25(L)" },
      { value: "NSK Ti-Max Ti25(L)", label: "NSK Ti-Max Ti25(L)" },
      { value: "NSK S-Max M25(L)", label: "NSK S-Max M25(L)" },
    ],
    "B.A. International": [
      {
        value: "BA 200LTS Ultimate Power +",
        label: "BA 200LTS Ultimate Power +",
      },
      { value: "BA 250(L)T Ultimate", label: "BA 250(L)T Ultimate" },
      {
        value: "BA 40 LSS Ultimate Power +",
        label: "BA 40 LSS Ultimate Power +",
      },
      { value: "BA 45(L)S Ultimate", label: "BA 45(L)S Ultimate" },
    ],
  },
  "Winkelstück Köpfe": {
    KaVo: [
      { value: "KaVo INTRAlux 68LD", label: "KaVo INTRAlux 68LD" },
      { value: "KaVo INTRAlux 68LH / L68", label: "KaVo INTRAlux 68LH / L68" },
      { value: "KaVo INTRAlux 67LH / L67", label: "KaVo INTRAlux 67LH / L67" },
      { value: "KaVo INTRAlux L80", label: "KaVo INTRAlux L80" },
    ],
  },
};

const Damages = [
  { id: "4A", label: "Spannzangen Haltekraft nicht ausreichend" },
  { id: "4B", label: "Drehzahl zu gering / Kugellager defekt" },
  { id: "4D", label: "Sprayprobleme" },
  { id: "4E", label: "Undichtigkeit / Abdichtung" },
  { id: "4F", label: "Bohrer steckt" },
  { id: "4G", label: "Läuft warm / macht komische Geräusche" },
  { id: "4H", label: "Sonstiges" },
];

const getCombination = (productType, manufacturer) => {
  const productId = ProductTypes.find((_productType) => _productType.value === productType)?.value;
  const manufacturerId = Manufacturers.find((_manufacturer) => _manufacturer.value === manufacturer)?.value;
  if (!productId || !manufacturerId) return false;
  return Models[productId] && Models[productId][manufacturerId];
};

export default function RepairPiece(props) {
  const { id, baseProps, index } = props;

  const { formValues } = baseProps;

  const productType = formValues[`${id}.productType`];
  const manufacturer = formValues[`${id}.manufacturer`];

  const internalForm = useFormHook();
  const damageCategoriesId = `${id}.damageCategories`;
  const damageDescriptionId = `${id}.damageDescription`;

  useEffect(() => {
    const { register, unregister } = baseProps;

    register(damageCategoriesId, "");
    register(damageDescriptionId, "");
    return () => {
      unregister(damageCategoriesId);
      unregister(damageDescriptionId);
    };
  }, [baseProps.register, baseProps.unregister]);

  useEffect(() => {
    const { setValue } = baseProps;
    const selectedValues = Object.entries(internalForm.formValues)
      .filter(([key, value]) => value)
      .map(([key, value]) => key)
      .filter((field) => field !== "damageDescription");
    const damageTypes = selectedValues.join(", ");
    const damageDescriptions = selectedValues
      .map((damageId) =>
        damageId === "4H"
          ? internalForm.formValues.damageDescription
          : Damages.find((damage) => damage.id === damageId).label
      )
      .join("\n");
    setValue(damageCategoriesId, damageTypes);
    setValue(damageDescriptionId, damageDescriptions);
  }, [internalForm.formValues]);

  return (
    <div className="p-4 my-4 border-2 border-gray-400">
      <div className="flex justify-between">
        <label className="my-2 text-xl font-semibold">Instrument {index + 1}</label>
        {props.delete && (
          <button
            className="p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0"
            onClick={props.delete}
          >
            <span className="block text-3xl text-black bg-transparent h-7 w-7">
              <GrFormTrash />
            </span>
          </button>
        )}
      </div>
      <div className="flex flex-wrap -mx-4">
        <Select
          id={`${id}.productType`}
          label="Produktart"
          placeholder="Bitte auswählen"
          required
          className="w-1/2 px-4"
          withMisc
          {...baseProps}
          options={ProductTypes}
        />
        <Select
          id={`${id}.manufacturer`}
          label="Hersteller"
          placeholder="Bitte auswählen"
          required
          className="w-1/2 px-4"
          withMisc
          {...baseProps}
          options={Manufacturers}
        />
      </div>
      {getCombination(productType, manufacturer) ? (
        <Select
          id={`${id}.model`}
          label="Hersteller"
          placeholder="Bitte auswählen"
          required
          withMisc
          {...baseProps}
          options={getCombination(productType, manufacturer)}
        />
      ) : (
        <Input id={`${id}.model`} label="Modell" required {...baseProps} />
      )}
      <Input id={`${id}.serialNumber`} label="Seriennummer" required {...baseProps} />
      <label className="block my-2 font-semibold">Schadensbeschreibung *</label>
      <div className="flex flex-wrap -mx-4">
        {Damages.map(({ id, label }) => (
          <Checkbox className="px-4 py-2" key={id} id={id} label={label} {...internalForm} />
        ))}
      </div>
      {internalForm.formValues["4H"] && (
        <Textarea id="damageDescription" required {...internalForm} errorMessage="Dies ist ein Pflichtfeld" />
      )}
    </div>
  );
}
